var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImagesSelect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9521 10.1841V1.65618C13.9521 0.874457 13.326 0.234863 12.5608 0.234863H4.21298C3.44776 0.234863 2.82167 0.874457 2.82167 1.65618V10.1841C2.82167 10.9658 3.44776 11.6054 4.21298 11.6054H12.5608C13.326 11.6054 13.9521 10.9658 13.9521 10.1841ZM6.57819 7.71811L7.71211 9.26735L9.50689 6.97903C9.64602 6.80136 9.91037 6.80136 10.0495 6.97903L12.1086 9.60847C12.2895 9.84298 12.1295 10.1841 11.8373 10.1841H4.90863C4.62341 10.1841 4.45645 9.85009 4.63037 9.61557L6.02167 7.71811C6.1608 7.53334 6.43906 7.53334 6.57819 7.71811ZM0.0390625 3.78816V13.0267C0.0390625 13.8085 0.665149 14.4481 1.43037 14.4481H10.4738C10.8565 14.4481 11.1695 14.1283 11.1695 13.7374C11.1695 13.3465 10.8565 13.0267 10.4738 13.0267H2.12602C1.74341 13.0267 1.43037 12.7069 1.43037 12.3161V3.78816C1.43037 3.3973 1.11732 3.0775 0.734715 3.0775C0.352106 3.0775 0.0390625 3.3973 0.0390625 3.78816Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImagesSelect);
export default __webpack_public_path__ + "static/media/images-select.859abfed34d6864a30565ae4a4ffafbd.svg";
export { ForwardRef as ReactComponent };